import NextStepsStepPage from './MedicationNextSteps.page';

export default NextStepsStepPage;
